import * as Nifty from "./nifty";
export default Nifty;
